module.exports = __webpack_public_path__ + "static/media/32.c7fac509.jpg";